import type {
  RIGHTS_ACCESS_RIGHTS_TEMPLATES,
  RIGHTS_ANALYTICS,
  RIGHTS_BRANCHES,
  RIGHTS_CHAINS,
  RIGHTS_CLIENT_SERVICES,
  RIGHTS_CLIENTS,
  RIGHTS_DATA_MIGRATIONS,
  RIGHTS_SALES_REGISTER,
  RIGHTS_HISTORY,
  RIGHTS_INTEGRATIONS,
  RIGHTS_IS_ASSIGN,
  RIGHTS_IS_ATTACH,
  RIGHTS_IS_CATEGORY_CREATE,
  RIGHTS_IS_CATEGORY_DELETE,
  RIGHTS_IS_CATEGORY_EDIT,
  RIGHTS_IS_CHANGE_STATUS,
  RIGHTS_IS_CLIENT_SERVICES,
  RIGHTS_IS_COMMUNICATE,
  RIGHTS_IS_CREATE,
  RIGHTS_IS_CREATE_COLLECTION,
  RIGHTS_IS_CREATE_EXPENSE,
  RIGHTS_IS_CREATE_SERVICES,
  RIGHTS_IS_DELETE,
  RIGHTS_IS_DELETE_COLLECTION,
  RIGHTS_IS_DELETE_EXPENSE,
  RIGHTS_IS_DELETE_SALE,
  RIGHTS_IS_EDIT,
  RIGHTS_IS_EDIT_ALL,
  RIGHTS_IS_EDIT_SERVICES,
  RIGHTS_IS_EMPLOYEES_REGISTER,
  RIGHTS_IS_EXPORT,
  RIGHTS_IS_FINANCIAL_STATISTICS,
  RIGHTS_IS_IMPORT,
  RIGHTS_IS_JOURNAL,
  RIGHTS_IS_PAY_RECORD,
  RIGHTS_IS_REGISTER,
  RIGHTS_IS_SERVICE_CATEGORIES,
  RIGHTS_IS_SHOW_CONTACTS,
  RIGHTS_IS_STATUSES,
  RIGHTS_IS_TOPPING_UP_CASH,
  RIGHTS_IS_VIEW_ALL,
  RIGHTS_IS_VIEW_ALL_RECORDS,
  RIGHTS_IS_VIEW_COMMUNICATION,
  RIGHTS_LEADS,
  RIGHTS_LEGAL_ENTITIES,
  RIGHTS_MODULES,
  RIGHTS_PAYMENT_ACCOUNTS,
  RIGHTS_POSITIONS,
  RIGHTS_RECORDS,
  RIGHTS_SALE_PLANS,
  RIGHTS_SALES_FUNNELS,
  RIGHTS_CRM_TASKS,
  RIGHTS_USERS,
  RIGHTS_WORK_SCHEDULES,
  RIGHTS_SENDOUTS,
  RIGHTS_IS_TOP_CLIENT_BALANCE,
  RIGHTS_IS_CREATE_TEMPLATES,
  RIGHTS_IS_DELETE_TEMPLATES,
  RIGHTS_IS_OWNER_CHANGE,
  RIGHTS_IS_TAGS_CHANGE,
  RIGHTS_IS_ALLOW_SPAM,
  RIGHTS_IS_TAKE,
  RIGHTS_IS_SALE_FUNNEL_CHANGE,
  RIGHTS_IS_EDIT_PAST,
  RIGHTS_IS_DELETE_PAST,
  RIGHTS_IS_FUNNEL_CREATE,
  RIGHTS_IS_FUNNEL_EDIT,
  RIGHTS_IS_FUNNEL_DELETE,
  RIGHTS_IS_STAGE_CREATE,
  RIGHTS_IS_STAGE_DELETE,
  RIGHTS_IS_STAGE_EDIT,
  RIGHTS_IS_CHANGE_BRANCHES,
  RIGHTS_IS_CHANGE_OWNER,
  RIGHTS_IS_USER,
  RIGHTS_AI,
  RIGHTS_IS_CONTROL,
  RIGHTS_IS_VIEW_RECEIVERS,
  RIGHTS_ORGANIZATIONS,
  RIGHTS_SECRET_LOGIN_TO_ORGANIZATION_ACCOUNT,
  RIGHTS_IS_EDITING_RIGHTS_WITHIN_OPEN_RIGHTS,
  RIGHTS_MESSAGE_TEMPLATES,
  RIGHTS_IS_RETURN_MONEY,
  FINANCIAL_INCOMES_REPORT,
  FINANCIAL_FACT_IMPL_REPORT,
  FINANCIAL_EXPENSE_BY_ARTICLES_REPORT,
  FINANCIAL_PNL_REPORT,
  FINANCIAL_DETAILS_OF_EXPENSES_REPORT,
  RIGHTS_SALARIES,
  RIGHTS_WAREHOUSE,
  RIGHTS_PRODUCTS,
  RIGHTS_MEDICAL_DOCUMENTS,
  RIGHTS_IS_VIEW_REMINDERS,
  RIGHTS_IS_EDIT_REMINDERS,
} from '@app/constants';
import {
  SENDOUTS_MODULE_KEY,
  LEADS_MODULE_KEY,
  INTEGRATIONS_MODULE_KEY,
  AI_MODULE_KEY,
  RECORDS_MODULE_KEY,
  SALES_FUNNELS_MODULE_KEY,
  TASKS_MODULE_KEY,
  WHATS_APP_INTEGRATIONS_MODULE_KEY,
  LOYALTY_MODULE_KEY,
} from '@app/constants';
import type { NUsers, NAuth } from '@app/types';

export namespace NAccessRights {
  export type EntityId = keyof PropsWithSpecificRights;

  export type SpecificRight =
    | GeneralEntityRights
    | TypicalSpecificRights
    | RightsForChains
    | RightsForBranches
    | RightsForUsers
    | RightsForClients
    | RightsForRecords
    | RightsForSalePlans
    | RightsForFinancialOperations
    | RightsForAccessRightTemplates
    | RightsForClientServices
    | RightsForMigrationYClients
    | RightsForLeads
    | RightsForWorkSchedules
    | RightsForSaleFunnels
    | RightsForCrmTasks
    | RightsForSendouts
    | RightsForOrganizations;

  export type SpecificRightKey =
    | keyof GeneralEntityRights
    | keyof TypicalSpecificRights
    | keyof RightsForChains
    | keyof RightsForBranches
    | keyof RightsForUsers
    | keyof RightsForClients
    | keyof RightsForRecords
    | keyof RightsForSalePlans
    | keyof RightsForFinancialOperations
    | keyof RightsForAccessRightTemplates
    | keyof RightsForClientServices
    | keyof RightsForMigrationYClients
    | keyof RightsForLeads
    | keyof RightsForWorkSchedules
    | keyof RightsForSaleFunnels
    | keyof RightsForCrmTasks
    | keyof RightsForSendouts
    | keyof RightsForOrganizations;

  export type PropsWithSpecificRights = {
    [RIGHTS_ANALYTICS]: GeneralEntityRights;
    [RIGHTS_SALARIES]: GeneralEntityRights;
    [RIGHTS_PAYMENT_ACCOUNTS]: TypicalSpecificRights;
    [RIGHTS_CHAINS]: RightsForChains;
    [RIGHTS_BRANCHES]: RightsForBranches;
    [RIGHTS_USERS]: RightsForUsers;
    [RIGHTS_CLIENTS]: RightsForClients;
    [RIGHTS_RECORDS]: RightsForRecords;
    [RIGHTS_LEGAL_ENTITIES]: TypicalSpecificRights;
    [RIGHTS_INTEGRATIONS]: TypicalSpecificRights;
    [RIGHTS_SALE_PLANS]: RightsForSalePlans;
    [RIGHTS_SALES_REGISTER]: RightsForFinancialOperations;
    [RIGHTS_ACCESS_RIGHTS_TEMPLATES]: RightsForAccessRightTemplates;
    [RIGHTS_CLIENT_SERVICES]: RightsForClientServices;
    [RIGHTS_POSITIONS]: TypicalSpecificRights;
    [RIGHTS_DATA_MIGRATIONS]: RightsForMigrationYClients;
    [RIGHTS_LEADS]: RightsForLeads;
    [RIGHTS_WORK_SCHEDULES]: RightsForWorkSchedules;
    [RIGHTS_SALES_FUNNELS]: RightsForSaleFunnels;
    [RIGHTS_HISTORY]: GeneralEntityRights;
    [RIGHTS_CRM_TASKS]: RightsForCrmTasks;
    [RIGHTS_SENDOUTS]: RightsForSendouts;
    [RIGHTS_AI]: GeneralEntityRights;
    [RIGHTS_ORGANIZATIONS]: RightsForOrganizations;
    [RIGHTS_MESSAGE_TEMPLATES]: GeneralEntityRights;
    [RIGHTS_WAREHOUSE]: RightsForWarehouses;
    [RIGHTS_PRODUCTS]: RightsForProducts;
    // Опциональный: legacy-ответы бэка блока MedicalDocuments не содержат
    // (бэковая часть — us/10241), фронт живёт на дефолтах из
    // accessRightsInitialState.
    [RIGHTS_MEDICAL_DOCUMENTS]?: RightsForMedicalDocuments;
  };

  export type ModelAccessRights = PropsWithSpecificRights & {
    UserId: NAuth.UserPrint['userId'];
    IsAdmin: boolean;
    IsSuperAdmin: boolean;
    [RIGHTS_MODULES]: AccessRightsModuleDto[] | null;
  };

  export interface GeneralEntityRights {
    IsOn: boolean;
  }

  export type GenerateOptions = (
    accessRights: ModelAccessRights,
    entityId: EntityId,
    rightsList: RightsListItem[]
  ) => JSX.Element;

  export type RightsListItem = {
    specificRightId: SpecificRightKey;
    label: string;
  };

  export type AccessRightsModuleDto = {
    Name: string | null;
    RightType: RightType;
    Allowed: boolean;
  };

  export enum RightType {
    LEADS = LEADS_MODULE_KEY,
    INTEGRATIONS = INTEGRATIONS_MODULE_KEY,
    TASKS = TASKS_MODULE_KEY,
    RECORDS = RECORDS_MODULE_KEY,
    SALES_FUNNELS = SALES_FUNNELS_MODULE_KEY,
    WHATS_APP_INTEGRATIONS = WHATS_APP_INTEGRATIONS_MODULE_KEY,
    SENDOUTS = SENDOUTS_MODULE_KEY,
    AI = AI_MODULE_KEY,
    LOYALTY = LOYALTY_MODULE_KEY,
  }

  export type ModuleRightsListPayload = {
    ActiveBranchId?: number;
  };

  export type ModuleRightsUpdatePayload = Array<
    Pick<NAccessRights.AccessRightsModuleDto, 'RightType' | 'Allowed'>
  >;

  export interface TypicalSpecificRights extends GeneralEntityRights {
    [RIGHTS_IS_CREATE]: boolean;
    [RIGHTS_IS_EDIT]: boolean;
    [RIGHTS_IS_DELETE]: boolean;
  }

  export type RightsForChains = Omit<
    TypicalSpecificRights,
    typeof RIGHTS_IS_DELETE
  >;

  export type RightsForBranches = Omit<
    TypicalSpecificRights,
    typeof RIGHTS_IS_DELETE
  >;

  export interface RightsForUsers extends GeneralEntityRights {
    [RIGHTS_IS_CREATE_SERVICES]: boolean;
    [RIGHTS_IS_EDIT_SERVICES]: boolean;
    [RIGHTS_IS_EMPLOYEES_REGISTER]: boolean;

    // На 26.12.2024 в Сваггере не было этих специальных прав, однако сервер возвращал их
    // для загрузки списка прав, а также принимал их на вход при сохранении выбранных прав пользователем
    [RIGHTS_IS_USER]: boolean;
    [RIGHTS_IS_CHANGE_OWNER]: boolean;
    [RIGHTS_IS_CHANGE_BRANCHES]: boolean;
  }

  export type RightsForClients = TypicalSpecificRights & {
    [RIGHTS_IS_EXPORT]: boolean;
    [RIGHTS_IS_COMMUNICATE]: boolean;
    [RIGHTS_IS_VIEW_COMMUNICATION]: boolean;
    [RIGHTS_IS_SHOW_CONTACTS]: boolean;
  };

  type NewType = {
    [RIGHTS_IS_EXPORT]: boolean;
    [RIGHTS_IS_JOURNAL]: boolean;
    [RIGHTS_IS_REGISTER]: boolean;
    [RIGHTS_IS_STATUSES]: boolean;
    [RIGHTS_IS_VIEW_ALL_RECORDS]: boolean;
    [RIGHTS_IS_PAY_RECORD]: boolean;
    [RIGHTS_IS_FINANCIAL_STATISTICS]: boolean;
    [RIGHTS_IS_VIEW_REMINDERS]: boolean;
    [RIGHTS_IS_EDIT_REMINDERS]: boolean;
  };

  export type RightsForRecords = TypicalSpecificRights & NewType;

  export type RightsForClientServices = TypicalSpecificRights & {
    [RIGHTS_IS_CLIENT_SERVICES]: boolean;
    [RIGHTS_IS_SERVICE_CATEGORIES]: boolean;
    [RIGHTS_IS_EXPORT]: boolean;
    [RIGHTS_IS_IMPORT]: boolean;
    [RIGHTS_IS_CATEGORY_CREATE]: boolean;
    [RIGHTS_IS_CATEGORY_EDIT]: boolean;
    [RIGHTS_IS_CATEGORY_DELETE]: boolean;
    [RIGHTS_IS_ATTACH]: boolean;
  };

  export type RightsForAnalytics = GeneralEntityRights & {
    [FINANCIAL_INCOMES_REPORT]: boolean;
    [FINANCIAL_FACT_IMPL_REPORT]: boolean;
    [FINANCIAL_EXPENSE_BY_ARTICLES_REPORT]: boolean;
    [FINANCIAL_PNL_REPORT]: boolean;
    [FINANCIAL_DETAILS_OF_EXPENSES_REPORT]: boolean;
  };

  export type RightsForSalePlans = Pick<
    TypicalSpecificRights,
    'IsOn' | 'IsCreate'
  > & {
    [RIGHTS_IS_EXPORT]: boolean;
  };

  export type RightsForMigrationYClients = Pick<
    TypicalSpecificRights,
    'IsOn' | 'IsCreate'
  >;

  export type RightsForLeads = Pick<
    TypicalSpecificRights,
    'IsOn' | 'IsDelete'
  > & {
    [RIGHTS_IS_OWNER_CHANGE]: boolean;
    [RIGHTS_IS_TAGS_CHANGE]: boolean;
    [RIGHTS_IS_VIEW_ALL]: boolean;
    [RIGHTS_IS_ALLOW_SPAM]: boolean;
    [RIGHTS_IS_TAKE]: boolean;
    [RIGHTS_IS_SALE_FUNNEL_CHANGE]: boolean;
    [RIGHTS_IS_COMMUNICATE]: boolean;
  };

  export type RightsForWorkSchedules = TypicalSpecificRights & {
    [RIGHTS_IS_EDIT_PAST]: boolean;
    [RIGHTS_IS_DELETE_PAST]: boolean;
  };

  export type RightsForSaleFunnels = GeneralEntityRights & {
    [RIGHTS_IS_FUNNEL_CREATE]: boolean;
    [RIGHTS_IS_FUNNEL_EDIT]: boolean;
    [RIGHTS_IS_FUNNEL_DELETE]: boolean;
    [RIGHTS_IS_STAGE_CREATE]: boolean;
    [RIGHTS_IS_STAGE_EDIT]: boolean;
    [RIGHTS_IS_STAGE_DELETE]: boolean;
  };

  export type RightsForFinancialOperations = GeneralEntityRights & {
    [RIGHTS_IS_DELETE_SALE]: boolean;
    [RIGHTS_IS_CREATE_EXPENSE]: boolean;
    [RIGHTS_IS_CREATE_COLLECTION]: boolean;
    [RIGHTS_IS_TOPPING_UP_CASH]: boolean;
    [RIGHTS_IS_DELETE_EXPENSE]: boolean;
    [RIGHTS_IS_DELETE_COLLECTION]: boolean;
    [RIGHTS_IS_TOP_CLIENT_BALANCE]: boolean;
    [RIGHTS_IS_RETURN_MONEY]: boolean;
    [RIGHTS_IS_EXPORT]: boolean;
  };

  export type RightsForCrmTasks = TypicalSpecificRights & {
    [RIGHTS_IS_VIEW_ALL]: boolean;
    [RIGHTS_IS_ASSIGN]: boolean;
    [RIGHTS_IS_EDIT_ALL]: boolean;
    [RIGHTS_IS_CHANGE_STATUS]: boolean;
  };

  export type RightsForSendouts = Pick<
    TypicalSpecificRights,
    'IsOn' | 'IsCreate'
  > & {
    [RIGHTS_IS_CREATE]: boolean;
    [RIGHTS_IS_CONTROL]: boolean;
    [RIGHTS_IS_VIEW_RECEIVERS]: boolean;
  };

  export type RightsForOrganizations = GeneralEntityRights & {
    [RIGHTS_SECRET_LOGIN_TO_ORGANIZATION_ACCOUNT]: boolean;
  };

  export interface RightsForWarehouses {
    IsInventoryComplete: boolean;
    IsInventoryCompleting: boolean;
    IsInventoryCreate: boolean;
    IsInventoryDelete: boolean;
    IsInventoryEdit: boolean;
    IsInventoryReports: boolean;
    IsOn: boolean;
    IsProductItemsAccept: boolean;
    IsProductItemsDecomission: boolean;
    IsProductItemsDelete: boolean;
    IsProductItemsMove: boolean;
    IsSupplierCreate: boolean;
    IsSupplierDelete: boolean;
    IsSupplierEdit: boolean;
    IsSuppliers: boolean;
    IsWarehouseCreate: boolean;
    IsWarehouseDelete: boolean;
    IsWarehouseEdit: boolean;
  }

  export interface RightsForProducts {
    IsBrandCreate: boolean;
    IsBrandDelete: boolean;
    IsBrandEdit: boolean;
    IsBrands: boolean;
    IsOn: boolean;
    IsProductCategories: boolean;
    IsProductCategoryCreate: boolean;
    IsProductCategoryDelete: boolean;
    IsProductCategoryEdit: boolean;
    IsProductCreate: boolean;
    IsProductDelete: boolean;
    IsProductEdit: boolean;
  }

  export interface RightsForMedicalDocuments {
    IsOn: boolean;
    IsEdit: boolean;
    IsSign: boolean;
    IsSend: boolean;
    IsViewAll: boolean;
  }

  export type RightsForAccessRightTemplates = Pick<
    TypicalSpecificRights,
    'IsOn' | 'IsEdit'
  > & {
    [RIGHTS_IS_CREATE_TEMPLATES]: boolean;
    [RIGHTS_IS_DELETE_TEMPLATES]: boolean;
    [RIGHTS_IS_EDITING_RIGHTS_WITHIN_OPEN_RIGHTS]: boolean;
  };

  export type ModelAccessRightsTemplate = {
    Id: number;
    TimeCreated: string;
    CreateUserId: NUsers.User['id'];
    FromUserId: NUsers.User['id'];
    Name: string;
    Description: string;
    IsDeleted: boolean;
    ModelAccessRights: ModelAccessRights;
  };

  export type ModelApplyAccessRightsTemplate = {
    AccessRightsTemplateId: number;
    UserId: number;
  };
}
